"use strict";

var _interopRequireDefault = require("@babel/runtime-corejs2/helpers/interopRequireDefault");

var _Object$defineProperty = require("@babel/runtime-corejs2/core-js/object/define-property");

_Object$defineProperty(exports, "__esModule", {
  value: true
});

exports["default"] = void 0;

var _construct = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/reflect/construct"));

var _assign = _interopRequireDefault(require("@babel/runtime-corejs2/core-js/object/assign"));

var _classCallCheck2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/classCallCheck"));

var _createClass2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/createClass"));

var _assertThisInitialized2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/assertThisInitialized"));

var _inherits2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/inherits"));

var _possibleConstructorReturn2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/possibleConstructorReturn"));

var _get2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/get"));

var _getPrototypeOf2 = _interopRequireDefault(require("@babel/runtime-corejs2/helpers/getPrototypeOf"));

var _react = _interopRequireDefault(require("react"));

var _propTypes = _interopRequireDefault(require("prop-types"));

var _reflux = _interopRequireDefault(require("reflux"));

var _Button = _interopRequireDefault(require("react-mdl/lib/Button"));

var _DeviceInfoHelper = _interopRequireDefault(require("../../../helpers/DeviceInfoHelper"));

var _ThemeStore = _interopRequireDefault(require("../ThemeStore/ThemeStore2"));

var _config = _interopRequireDefault(require("../../../../targets/cord_eurofh_teams/config.js"));

var _styles = _interopRequireDefault(require("./styles.scss"));

var _ObjectHelper = require("../../../helpers/ObjectHelper");

var _ColorHelper = require("../../../helpers/ColorHelper");

var _StoreComponent2 = _interopRequireDefault(require("../../../KESI2/Stores/StoreComponent"));

var _NavigationManagerCordova = _interopRequireDefault(require("../../NavigationManagerCordova"));

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = (0, _getPrototypeOf2["default"])(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = (0, _getPrototypeOf2["default"])(this).constructor; result = (0, _construct["default"])(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return (0, _possibleConstructorReturn2["default"])(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !_construct["default"]) return false; if (_construct["default"].sham) return false; if (typeof Proxy === "function") return true; try { Date.prototype.toString.call((0, _construct["default"])(Date, [], function () {})); return true; } catch (e) { return false; } }

var Button = /*#__PURE__*/function (_StoreComponent) {
  (0, _inherits2["default"])(Button, _StoreComponent);

  var _super = _createSuper(Button);

  function Button(props) {
    var _thisSuper, _this;

    (0, _classCallCheck2["default"])(this, Button);
    _this = _super.call(this, props);
    _this.state = {
      button: null
    };
    (0, _get2["default"])((_thisSuper = (0, _assertThisInitialized2["default"])(_this), (0, _getPrototypeOf2["default"])(Button.prototype)), "addStoresAndKeys", _thisSuper).call(_thisSuper, [{
      store: _ThemeStore["default"],
      keys: ['quiz', 'button', 'navbar', 'currentTheme']
    }]);
    return _this;
  }

  (0, _createClass2["default"])(Button, [{
    key: "render",
    value: function render() {
      var classNames = [_styles["default"].button, 'doNotInvert'];
      var defaultStyle = {
        borderRadius: '3px',
        fontSize: '16px',
        lineHeight: '18px',
        fontWeight: '900',
        textTransform: _config["default"].allButtonsUpperCase ? 'uppercase' : 'none',
        minHeight: '50px',
        maxHeight: '60px',
        width: this.props.width
      };
      var buttonTheme = null;
      var navbarTheme = null;
      var quizTheme = null;

      if (this.state.button && this.state.currentTheme in this.state.button) {
        buttonTheme = this.state.button[this.state.currentTheme];
      }

      if (this.state.navbar && this.state.currentTheme in this.state.navbar) {
        navbarTheme = this.state.navbar[this.state.currentTheme];
      }

      if (this.state.quiz && this.state.currentTheme in this.state.quiz) {
        quizTheme = this.state.quiz[this.state.currentTheme];
      }

      var defaultNavbarTheme = this.state.navbar ? this.state.navbar["default"] : null;
      var defaultButtonTheme = this.state.button ? this.state.button["default"] : null;
      var defaultQuizTheme = this.state.quiz ? this.state.quiz["default"] : null;
      var style = {};

      if (this.props.theme === 'navbar') {
        style = {
          border: "1px ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(navbarTheme, 'navbarBackground', defaultNavbarTheme, 'navbarBackground', _ColorHelper.COLOR.WHITE), " solid"),
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(navbarTheme, 'navbarText', defaultNavbarTheme, 'navbarText', _ColorHelper.COLOR.BLACK),
          backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(navbarTheme, 'navbarBackground', defaultNavbarTheme, 'navbarBackground', _ColorHelper.COLOR.WHITE)
        };
      } else if (this.props.theme === 'transparent') {
        style = {
          border: 'rgba(0,0,0,0)',
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(navbarTheme, 'navbarText', defaultNavbarTheme, 'navbarText', _ColorHelper.COLOR.BLACK),
          backgroundColor: 'rgba(0,0,0,0)'
        };
      } else if (this.props.theme === 'close') {
        style = {
          border: 'rgba(0,0,0,0)',
          color: 'rgba(0,0,0,0.5)',
          backgroundColor: 'rgba(0,0,0,0)'
        };
      } else if (this.props.theme === 'olaf') {
        style = {
          border: 'rgba(0,0,0,0)',
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(quizTheme, 'quizText', defaultQuizTheme, 'quizText', _ColorHelper.COLOR.BLACK),
          backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(quizTheme, 'answerBoxColor', defaultQuizTheme, 'answerBoxColor', _ColorHelper.COLOR.BLACK)
        };
      } else if (this.props.theme === 'light') {
        style = {
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaptionLight', defaultButtonTheme, 'buttonCaptionLight', _ColorHelper.COLOR.BLACK),
          backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBackgroundLight', defaultButtonTheme, 'buttonBackgroundLight', _ColorHelper.COLOR.WHITE),
          border: "1px ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBorderLight', defaultButtonTheme, 'buttonBorderLight', _ColorHelper.COLOR.WHITE), " solid")
        };
      } else if (this.props.theme === 'blue') {
        if (!this.props.disabled) {
          style = {
            color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaptionBlue', defaultButtonTheme, 'buttonCaptionBlue', _ColorHelper.COLOR.BLACK),
            backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBackgroundBlue', defaultButtonTheme, 'buttonBackgroundBlue', _ColorHelper.COLOR.WHITE),
            border: "1px ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBorderBlue', defaultButtonTheme, 'buttonBorderBlue', _ColorHelper.COLOR.WHITE), " solid")
          };
        }
      } else if (this.props.theme === 'dark') {
        style = {
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaptionDark', defaultButtonTheme, 'buttonCaptionDark', _ColorHelper.COLOR.BLACK),
          backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBackgroundDark', defaultButtonTheme, 'buttonBackgroundDark', _ColorHelper.COLOR.WHITE),
          border: "1px ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBorderDark', defaultButtonTheme, 'buttonBorderDark', _ColorHelper.COLOR.WHITE), " solid")
        };
      } else if (this.props.theme === 'connectCode') {
        style = {
          fontSize: '16px',
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaptionDark', defaultButtonTheme, 'buttonCaptionDark', _ColorHelper.COLOR.BLACK),
          backgroundColor: 'rgba(0,0,0,0)',
          border: '0px',
          left: '50%',
          transform: 'translateX(-50%)',
          textDecoration: 'underline',
          width: '100%'
        };
      } else if (this.props.theme === 'pwReset') {
        style = {
          fontSize: '12px',
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaptionDark', defaultButtonTheme, 'buttonCaptionDark', _ColorHelper.COLOR.BLACK),
          backgroundColor: 'rgba(0,0,0,0)',
          border: '0px',
          position: 'absolute',
          left: '50%',
          height: '30px',
          transform: 'translateX(-50%)',
          bottom: '70px',
          textDecoration: 'underline',
          width: '80%',
          minHeight: '10px'
        };
      } else if (this.props.theme === 'pwReset2') {
        style = {
          fontSize: '12px',
          color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaptionDark', defaultButtonTheme, 'buttonCaptionDark', _ColorHelper.COLOR.BLACK),
          backgroundColor: 'rgba(0,0,0,0)',
          textDecoration: 'underline',
          height: '30px',
          minHeight: '10px'
        };
      } else if (this.props.forcedColor) {
        style = {
          color: _ColorHelper.COLOR.WHITE,
          backgroundColor: this.props.forcedColor,
          border: "1px ".concat(this.props.forcedColor, " solid")
        };
      } else {
        if (this.props.disabled) {
          style = {
            color: '#FFFFFF',
            backgroundColor: '#6a6a6a',
            border: "1px #6a6a6a solid"
          };
        } else {
          style = {
            color: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonCaption', defaultButtonTheme, 'buttonCaptionLight', _ColorHelper.COLOR.BLACK),
            backgroundColor: (0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBackground', defaultButtonTheme, 'buttonBackground', _ColorHelper.COLOR.WHITE),
            border: "1px ".concat((0, _ObjectHelper.getObjectValueWithFallbacks)(buttonTheme, 'buttonBorder', defaultButtonTheme, 'buttonBorder', _ColorHelper.COLOR.WHITE), " solid")
          };
        }
      }

      if (this.props.className) {
        classNames.push(this.props.className);
      }

      if (!this.props.showBorder) {
        classNames.push(_styles["default"].noBorder);
      }

      if (this.props.disabled) {
        classNames.push(_styles["default"].disabled);
      }

      if (_DeviceInfoHelper["default"].isiOS()) {
        return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
          className: classNames.join(' '),
          onClick: this.props.onClick,
          type: this.props.type,
          disabled: this.props.disabled,
          style: _config["default"].requiredFeature === 'ergoquiz' ? null : (0, _assign["default"])({}, defaultStyle, style)
        }, this.props.children);
      }

      return /*#__PURE__*/_react["default"].createElement(_Button["default"], {
        id: this.props.id,
        className: classNames.join(' '),
        onClick: this.props.onClick,
        type: this.props.type,
        disabled: this.props.disabled,
        style: _config["default"].requiredFeature === 'ergoquiz' ? null : (0, _assign["default"])({}, defaultStyle, style)
      }, this.props.children);
    }
  }]);
  return Button;
}(_StoreComponent2["default"]);

exports["default"] = Button;
Button.propTypes = {
  className: _propTypes["default"].string,
  children: _propTypes["default"].node,
  onClick: _propTypes["default"].func,
  showBorder: _propTypes["default"].bool,
  type: _propTypes["default"].string,
  disabled: _propTypes["default"].bool,
  theme: _propTypes["default"].string,
  width: _propTypes["default"].string,
  forcedColor: _propTypes["default"].string
};
Button.defaultProps = {
  className: '',
  onClick: function onClick() {},
  showBorder: true,
  disabled: false
};